export default "__VITE_ASSET__CgbzY1g6__"